const _MENU = [
  {
    icon: "supervised_user_circle",
    name: "associado",
    text: "Associados",
    to: "/"
  },
  {
    icon: "group",
    name: "utilizador",
    text: "Utilizadores",
    to: "/utilizador"
  },
  {
    icon: "business",
    name: "instituicao",
    text: "Instituições",
    to: "/instituicao"
  }
  /*{
    icon: "home",
    name: "home",
    text: "Home",
    to: "/"
  },
  {
    icon: "favorite",
    name: "colheita",
    text: "Colheitas",
    to: "/colheita"
  },
  {
    icon: "local_hospital",
    name: "brigada",
    text: "Brigadas",
    to: "/brigada"
  },
  {
    icon: "location_city",
    name: "dadiva",
    text: "Dádivas",
    to: "/dadiva"
  },
  {
    icon: "emoji_events",
    name: "galardao_pedido",
    text: "Galardões pedidos",
    to: "/galardao_pedido"
  },
  {
    icon: "supervised_user_circle",
    name: "associado",
    text: "Associados",
    to: "/associado"
  },
  {
    icon: "money",
    name: "donativo",
    text: "Donativos",
    to: "/donativo"
  },
  {
    icon: "group",
    name: "utilizador",
    text: "Utilizadores",
    to: "/utilizador"
  },
  {
    icon: "business",
    name: "instituicao",
    text: "Instituições",
    to: "/instituicao"
  },
  {
    icon: "emoji_events",
    name: "galardao",
    text: "Tipos galardões",
    to: "/galardao"
  }*/
]

export default _MENU
